export const ADVANCE_ON_ACKNOWLEDGE_STRATEGY_VERSION = 2;
export const ADVANCE_ON_ACKNOWLEDGE_STRATEGY_NEXT_ITEM = "nextItem";
export const ADVANCE_ON_ACKNOWLEDGE_STRATEGY_NEXT_INCOMPLETE_ITEM = "nextIncompleteItem";

const CANONICAL_ADVANCE_ON_ACKNOWLEDGE_STRATEGIES = new Set([
	ADVANCE_ON_ACKNOWLEDGE_STRATEGY_NEXT_ITEM,
	ADVANCE_ON_ACKNOWLEDGE_STRATEGY_NEXT_INCOMPLETE_ITEM
]);

export function normalizeAdvanceOnAcknowledgeStrategy(source = {}) {
	const parsedVersion = Number(source && source.advanceOnAcknowledgeStrategyVersion);
	const requestedStrategy = source && source.advanceOnAcknowledgeStrategy;

	// Preserve contracts authored by a newer client instead of rewriting fields this client
	// does not understand. Updated runtimes still fail safely to next-item for unknown values.
	if (Number.isInteger(parsedVersion) && parsedVersion > ADVANCE_ON_ACKNOWLEDGE_STRATEGY_VERSION) {
		return {
			advanceOnAcknowledgeStrategyVersion: parsedVersion,
			advanceOnAcknowledgeStrategy: requestedStrategy
		};
	}

	const isCurrentVersion = parsedVersion === ADVANCE_ON_ACKNOWLEDGE_STRATEGY_VERSION;
	const strategy = isCurrentVersion && CANONICAL_ADVANCE_ON_ACKNOWLEDGE_STRATEGIES.has(requestedStrategy)
		? requestedStrategy
		: ADVANCE_ON_ACKNOWLEDGE_STRATEGY_NEXT_ITEM;

	return {
		advanceOnAcknowledgeStrategyVersion: ADVANCE_ON_ACKNOWLEDGE_STRATEGY_VERSION,
		advanceOnAcknowledgeStrategy: strategy
	};
}

export function applyAdvanceOnAcknowledgeStrategyMigration(target) {
	if (!target || typeof target !== "object") {
		return target;
	}

	Object.assign(target, normalizeAdvanceOnAcknowledgeStrategy(target));
	return target;
}
